const config = {
    soundstyle: 'classic',
    appName: 'Wintrado Neo Staging',
    appTitle: 'Wintrado - WebTrader Neo Staging',
    feedApi: {
        url: 'wss://gateway.staging.wintrado.com',
    },
    baseURL: 'https://gateway.staging.wintrado.com',
    cashier: {
        useIframe: true,
        baseURL: 'https://cashier.staging.wintrado.com',
        frontendURL: 'https://app.staging.wintrado.com',
    },
    oAuth: {
        clientId: 'webtrader-wintrado',
        clientSecret: 'rpjsSJvu1HIJvDCe',
    },
    affiliatePortalUrl: 'https://affiliate.staging.wintrado.com',
};
export default config;
